// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emailModal {
  border-radius: 30px;
  width: auto;
  height: 380px;
  margin: auto;
  /* overflow: hidden; */
  background-color: #f3f2f0 !important;
  /* border: 1px solid red; */
}

@media screen and (min-width: 425px){
  .emailModal {
    border-radius: 30px;
    width: 400px;
    height: 380px;
    overflow: hidden;
    background-color: #f3f2f0 !important;
    /* border: 1px solid red; */
    padding-top: 0px !important;
  }
}

.emailModal::-webkit-scrollbar {
  display: none;
 
}
.emailModal {
  scrollbar-width: none; /* Firefox */
}

.email-verification-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}


.modal-header {
  width: 100%;
  display: block;
  position: relative;
  text-align: center;
}
.modal-header .close {
  position: absolute;
  right: 30px;
  top: 20px;
  padding: 0.5rem;
}
.modal-content {
  background: none;
  border: none;
  display: unset;
  overflow: hidden;
}

.modal-dialog {
  max-width: 600px;
}

.text-head {
  font-size: 16px;
  color: #373334;
}
.text {
  font-size: 18px;
  margin-bottom: 10px;
  color: #373334;
}
.EnterCode input {
  width: 70%;
  border: none;
  background-color: transparent;
  font-size: 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #7d7d7c;
  /* margin-top: 20px; */
  /* margin-left: 45px; */
  color: #373334;
}
.EnterCode input:focus {
  outline: none;
}
input::placeholder {
  font-size: 18px;
  text-transform: capitalize;
  color: #a9a8a6;
}
.EnterCode {
  width: 300px;
  height: 35px;
  margin-top: 25px;
  background-color: #f3f2f0;
  border-radius: 20px;
  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
  font-weight: 500;
  color: #7a7a7a;
  display: flex;
  justify-content: center;
}
.ResendCode {
  display: inline-block;
  color: #7A7A7A;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin: 8px 0px;
  background-color: transparent;
}
.errorMessage {
  font-size: 14px;
  color: red;
  margin: 0px;
  padding: 0px;
}
.FinishSignUp {
  width: 80%;
  min-height: 45px;
  /* margin-left: 36px; */
  /* background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%); */
  border: 1px;  /* Remove the border property */
  border-radius: 40px; /* Set border-radius to 0 */
  font-size: 18px;
  font-weight: 400;
  text-transform: capitalize;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.FinishSignUp input:focus {
  outline: none;
}

.FinishSignUp:disabled {
  /* background: #e5e4e1;
  color: #7a7a7a; */
  cursor: not-allowed;
}

.ResendMessage {
  color: green;
  margin: 6px;
  font-size: 11px;
}
.close-button{
  position: absolute;
  right: 15px;
  top: -15px;
  background: transparent;
  border: none;
  font-size: 26px;
  font-weight: 400;
  cursor: pointer;
  color: #373334;
  outline: none !important;
}
.btnWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/EmailVerification/EmailverficationModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,oCAAoC;IACpC,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;;AAEf;AACA;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;8CAC4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,gFAAgF;EAChF,WAAW,GAAG,+BAA+B;EAC7C,mBAAmB,EAAE,2BAA2B;EAChD,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;mBACiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".emailModal {\r\n  border-radius: 30px;\r\n  width: auto;\r\n  height: 380px;\r\n  margin: auto;\r\n  /* overflow: hidden; */\r\n  background-color: #f3f2f0 !important;\r\n  /* border: 1px solid red; */\r\n}\r\n\r\n@media screen and (min-width: 425px){\r\n  .emailModal {\r\n    border-radius: 30px;\r\n    width: 400px;\r\n    height: 380px;\r\n    overflow: hidden;\r\n    background-color: #f3f2f0 !important;\r\n    /* border: 1px solid red; */\r\n    padding-top: 0px !important;\r\n  }\r\n}\r\n\r\n.emailModal::-webkit-scrollbar {\r\n  display: none;\r\n \r\n}\r\n.emailModal {\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n\r\n.email-verification-container{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n\r\n.modal-header {\r\n  width: 100%;\r\n  display: block;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n.modal-header .close {\r\n  position: absolute;\r\n  right: 30px;\r\n  top: 20px;\r\n  padding: 0.5rem;\r\n}\r\n.modal-content {\r\n  background: none;\r\n  border: none;\r\n  display: unset;\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-dialog {\r\n  max-width: 600px;\r\n}\r\n\r\n.text-head {\r\n  font-size: 16px;\r\n  color: #373334;\r\n}\r\n.text {\r\n  font-size: 18px;\r\n  margin-bottom: 10px;\r\n  color: #373334;\r\n}\r\n.EnterCode input {\r\n  width: 70%;\r\n  border: none;\r\n  background-color: transparent;\r\n  font-size: 14px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 2px solid #7d7d7c;\r\n  /* margin-top: 20px; */\r\n  /* margin-left: 45px; */\r\n  color: #373334;\r\n}\r\n.EnterCode input:focus {\r\n  outline: none;\r\n}\r\ninput::placeholder {\r\n  font-size: 18px;\r\n  text-transform: capitalize;\r\n  color: #a9a8a6;\r\n}\r\n.EnterCode {\r\n  width: 300px;\r\n  height: 35px;\r\n  margin-top: 25px;\r\n  background-color: #f3f2f0;\r\n  border-radius: 20px;\r\n  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n  font-weight: 500;\r\n  color: #7a7a7a;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.ResendCode {\r\n  display: inline-block;\r\n  color: #7A7A7A;\r\n  font-size: 16px;\r\n  border: none;\r\n  cursor: pointer;\r\n  margin: 8px 0px;\r\n  background-color: transparent;\r\n}\r\n.errorMessage {\r\n  font-size: 14px;\r\n  color: red;\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n.FinishSignUp {\r\n  width: 80%;\r\n  min-height: 45px;\r\n  /* margin-left: 36px; */\r\n  /* background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%); */\r\n  border: 1px;  /* Remove the border property */\r\n  border-radius: 40px; /* Set border-radius to 0 */\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  text-transform: capitalize;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.FinishSignUp input:focus {\r\n  outline: none;\r\n}\r\n\r\n.FinishSignUp:disabled {\r\n  /* background: #e5e4e1;\r\n  color: #7a7a7a; */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.ResendMessage {\r\n  color: green;\r\n  margin: 6px;\r\n  font-size: 11px;\r\n}\r\n.close-button{\r\n  position: absolute;\r\n  right: 15px;\r\n  top: -15px;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 26px;\r\n  font-weight: 400;\r\n  cursor: pointer;\r\n  color: #373334;\r\n  outline: none !important;\r\n}\r\n.btnWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
